import React, { useEffect, useRef, useState } from "react";
import { Footer } from "../footer";
import { Header } from "../header";
import { Carousel } from "antd";
import axios from "axios";
import "./service.css";
import service1 from "../../assets/images/Visual Identity design.svg"
import service2 from "../../assets/images/\Marketing & Advertising.svg"
import service3 from "../../assets/images/Publication Design.svg"
import service4 from "../../assets/images/Packaging Design.svg"
import service5 from "../../assets/images/Environmental Design.svg"
import service6 from "../../assets/images/Art and Illustration.svg"
import service7 from "../../assets/images/Signage Printing.svg"
import service8 from "../../assets/images/Offset Printing.svg"
import service9 from "../../assets/images/Binding & Finishing.svg"
import UpAnimationSize from "../../../src/components/UpAnimationSize";
import LeftRightAnimationSize from "../../../src/components/LeftRightAnimationSize";
import { baseUrl } from "../../../src/config"

export const Services = () => {
  const [services, setServices] = useState([]);
  const servicesRef: any = useRef();

  useEffect(() => {
    getServices();
    servicesRef?.current?.scrollIntoView({ behavior: 'smooth' });

  }, []);

  const getServices = async () => {
    try {
      const resp = await axios.get(`${baseUrl}services`); // Assuming your API endpoint is 'reviews'
      console.log(resp.data); // Log the response to check
      setServices(resp.data);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="services-container" ref={servicesRef}>
      <Header />
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        gap: 30,
        width: "80%",
      }}>
        <div className="heading">SERVICES</div>
        <div className="divider"></div>
        <div className="main-box">
          <UpAnimationSize>
          <div className="title underline-gradient">360° Designers Studio</div>
          </UpAnimationSize>
          <div className="inner-content">
            <div>
              <img className="image" src={service1}></img>
            </div>
            <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Visual Identity Design</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Logo | Visiting Cards | Letter Heads | Envelopes | ID Cards | Color Palates
                | Shapes and Patterns</div>
            </div>
          </div>
          <div className="inner-content">
            <div>
              <img className="image" src={service2}></img>
            </div>
            <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Marketing & Advertising Design</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Paper Advertisement | Social Media Ads | Direct mail ad design | Outdoor ad design | Print ad design | Social media ad design | Display ad design | Video ad design | Pamphlet ad design | Signage ad design | Roll-up banner ad design | Photo booth ad design | Display booth ad design | Branded merchandise ad design | Branding assets ad design</div>
            </div>
          </div>
          <div className="inner-content">
            <div>
              <img className="image" src={service3}></img>
            </div>
            <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Publication Design</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Books and book covers | Magazines | Newspapers | Pamphlets | Catalogs | Brochures | Reports | Manuals | Directories | Calendars | eBooks | Online magazines | Online newsletters | Blogs | Digital reports | Digital catalogs | Digital brochures</div>
            </div></div>
              <div className="inner-content">
            <div>
              <img className="image" src={service5}></img>
            </div>
            <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Packaging Design</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Boxes | Adornment packaging | Vacuum packaging | Bottles | Cans | Novelty packaging | Sustainable packaging</div>
            </div>
          </div>
          <div className="inner-content">
            <div>
              <img className="image" src={service4}></img>
            </div>
          
        
            <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Environmental Design</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Biophilic Design | Adaptive Reuse | Passive Design | Inclusive Design | Interactive Design | Sustainable Design</div>
            </div>
          </div>

          <div className="inner-content">
            <div>
              <img className="image" src={service6}></img>
            </div>
            <div style={{marginBottom:50}}>
              <LeftRightAnimationSize>
              <div className="sub-title">Art and Illustration</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Personal expression, emotion and interpretation | Digital Painting | Portrait Retouching | Redraw | Info graphs | Presentations</div>
            </div>
          </div>
          <UpAnimationSize>
          <div className="title underline-gradient">Printing Services
          </div>
          </UpAnimationSize>
          <div className="inner-content">
            <div>
              <img className="image" src={service7}></img>
            </div>
             <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Signage Printing (Solvent / Eco Solvent / UV)</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Books and book covers | Magazines | Newspapers | Pamphlets | Catalogs | Brochures | Reports | Manuals | Directories | Calendars | eBooks | Online magazines | Online newsletters | Blogs | Digital reports | Digital catalogs | Digital brochures
              </div>
            </div>
          </div>
          <div className="inner-content">
            <div>
              <img className="image" src={service8}></img>
            </div>
          
 <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Digital Printing & Offset Printing</div>
              </LeftRightAnimationSize>
              <div className="service-desc" style={{marginBottom:50}}>POD (Print on demand) | Single / Two / Multicolor Digital & Offset Printing | Letterheads | Visiting Cards | Invitations | Brochures & Pamphlets | ID Cards | Books | Magazines | News Papers | Posters | Industrial / Architectural Drawings (up to A0) | Stickers | Calendars | File Folders | Scribbling Pads | Diaries | Notebooks | Packaging Boxes | High Speed Scanning

              </div>
            </div>
          </div>
          <UpAnimationSize>
          <div className="title underline-gradient">Binding & Finishing Services
          </div>
          </UpAnimationSize>
          <div className="inner-content">
            <div>
              <img className="image" src={service9}></img>
            </div>
            <div>
              <LeftRightAnimationSize>
              <div className="sub-title">Binding & Finishing Services</div>
              </LeftRightAnimationSize>
              <div className="service-desc">Folding & Gathering | Perfect binding | Saddle-stitched & Wire Stitched binding | Hard-bound binding | Spiral & wire-o binding | Die Punching & Pasting | Thermal and Cold Lamination

              </div>
            </div>
          </div>
        </div>


        <div style={{ marginTop: 60, background: "#151515", width: window.innerWidth > 1000 ? "80%" : "100%", padding: "30px 0" }}>
          <div
  style={{
    fontSize:
      window.innerWidth <= 600
        ? 32 // mobile
        : window.innerWidth <= 1000
        ? 37 // tablet
        : 50, // desktop
    color: "#FFF",
    marginBottom: 25,
    fontWeight: "500",
    textAlign: "center",
  }}
>
  Our Projects
</div>
          {services?.length > 0 && <Carousel autoplay arrows>
            {services?.map((r, index) => (
              <div key={index} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "20px", background: "red" }}>
                <div style={{ backgroundColor: "#262626", color: "#FFF", width: "80%", paddingTop: 20, paddingBottom: 10 }}>
                  <div style={{ fontSize: 24, fontWeight: 600 }}>{r?.title}</div>
                </div>
                <div style={{ backgroundColor: "#262626", color: "#FFF", display: "flex", justifyContent: "center", width: "80%" }}>
                  <div style={{ fontSize: 18, width: "90%", height: 300, borderRadius: 4, background: "#fff", overflow: "hidden" }}>
                    {r?.profile && <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={r?.profile}></img>}
                  </div>
                </div>

                <div style={{ backgroundColor: "#262626", paddingBottom: "20px", color: "#FFF", width: "80%", paddingTop: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div style={{ fontSize: 18, width: "80%", textAlign: "center" }}>{r?.description}</div>
                </div>

              </div>
            ))}
          </Carousel>}
        </div>
      </div>

      <Footer />
    </div>
  );
};



